const getAssetSourcesToDelete = (initialPages, currentPages) => {
  const currentPageSources = new Set(currentPages.map((page) => page.source));
  return initialPages
    .filter((page) => !currentPageSources.has(page.source))
    .map((page) => page.source);
};

export default getAssetSourcesToDelete;
